import PropTypes from "prop-types";
import * as Yup from "yup";
import { Form, Formik } from "formik";
import { Button, CircularProgress, Grid, InputAdornment } from "@mui/material";
import PersonIcon from "@mui/icons-material/Person";
import { useEffect, useState } from "react";
import ChangePassword from "./change-password";
import { UserService } from "../../../../assets/_services/user-service";
import { openSuccessDialog } from "../../../../utils/ui-components/pop-ups/SuccessDialog";
import MultipleSelectCheckmarksWrapper from "../../../../utils/ui-components/FormsUI/MultipleSelectCheckmarks";
import { gridSpacing } from "../../../../store/constants";
import { UserAddValues } from "../ParentUsers/user-list";
import TextFieldWrapper from "../../../../utils/ui-components/FormsUI/TextField";
import SelectWrapper from "../../../../utils/ui-components/FormsUI/Select";
import SwitchWrapper from "../../../../utils/ui-components/FormsUI/Switch";
import { ChannelService } from "../../../../assets/_services/channel-service";
import { ApproverUserAddValues } from "./user-list";

UpdateParentUser.propTypes = {
  initialItem: PropTypes.object.isRequired,
  setOpen: PropTypes.func.isRequired,
  fetchData: PropTypes.func,
  initialData: PropTypes.object,
};

function UpdateParentUser({ initialItem, setOpen, fetchData, initialData }: any) {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingChannels, setIsLoadingChannels] = useState(false);

  return (
    <Grid container justifyContent={"center"}>
      <Grid item xs={12}>
        <Formik
          validateOnMount={true}
          initialValues={initialItem}
          enableReinitialize
          validationSchema={Yup.object().shape({
            companyName: Yup.string().required("Representative name is required"),
            username: Yup.string()
              .required("Username is required")
              .matches(/^[a-zA-Z0-9_]*$/, "Username can contain only letters, numbers, and underscores"),
            status: Yup.boolean().notRequired(),
          })}
          onSubmit={(values: ApproverUserAddValues, { setSubmitting, resetForm }) => {
            setIsLoading(true);
            let formData = {
              userId: values.id,
              companyName: values.companyName,
              userName: values.username,
              status: values.status ? 1 : 0,
              role: values.role,
            };
            UserService.updateApprover(formData).then((response) => {
              if (response.isSuccess) {
                openSuccessDialog("Success", `${formData.userName} updated successfully, ready to use`);
                fetchData();
                setIsLoading(false);
                resetForm({ values });
              } else {
                setSubmitting(false);
                setIsLoading(false);
              }
            });
          }}
        >
          {({ values, dirty, isSubmitting, isValid, setFieldValue, errors }) => (
            <Form>
              <Grid container columnSpacing={gridSpacing}>
                <Grid item xs={12} md={12}>
                  <TextFieldWrapper required label="Company Name" name="companyName" type="text" />
                </Grid>
                <Grid item xs={12}>
                  <TextFieldWrapper
                    type={"text"}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <PersonIcon />
                        </InputAdornment>
                      ),
                    }}
                    name="username"
                    placeholder="Username"
                    required
                  />
                </Grid>
                <Grid item lg={4} md={4} sm={6} xs={12}>
                  <SwitchWrapper name="status" label={values.status ? "ACTIVE" : "INACTIVE"} style={{ co: "green" }} />
                </Grid>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Grid
                    item
                    xs={12}
                    sx={{
                      display: "flex",
                      justifyContent: "flex-end",
                      py: 2,
                    }}
                  >
                    <Button
                      color="primary"
                      variant="contained"
                      type="submit"
                      // onClick={()=>{console.log(values)}}
                      disabled={!dirty || isSubmitting || !isValid}
                      startIcon={isLoading && <CircularProgress size={"20px"} sx={{ color: "gray" }} />}
                    >
                      Update Approver
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </Grid>

      <Grid item xs={12}>
        <ChangePassword
          fetchData={fetchData}
          setOpen={setOpen}
          initialItem={{
            password: "",
            confirmPassword: "",
            userId: initialItem.id,
            role: initialItem.role,
          }}
        />
      </Grid>
    </Grid>
  );
}

export default UpdateParentUser;
